import { Button } from 'antd';
import { AModal } from '../../../components';
import { IFinancial } from '../../../shared/interfaces';
import { CloseOutlined } from '@ant-design/icons';
import { MdReceiptLong } from 'react-icons/md';
import { FinancialReceiptReport } from '../../../shared/reports';
import { useEffect, useState } from 'react';

interface IFinancialReceiptProps {
  open: boolean;
  close: () => void;
  selectRows: IFinancial[];
}

const FinancialReceipt: React.FC<IFinancialReceiptProps> = ({
  open,
  close,
  selectRows,
}) => {
  const [financial, setFinancial] = useState<IFinancial | null>(null);

  useEffect(() => {
    if (selectRows.length) {
      setFinancial(selectRows[0]);
    }
  }, [open, selectRows]);

  return (
    <AModal
      open={open}
      close={close}
      width={900}
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <MdReceiptLong style={{ fontSize: 20 }} />
          <span>
            Visualizar Recibo {financial?.code ? `nº ${financial.code}` : ''}
          </span>
        </div>
      }
      footer={[
        <Button key="close" onClick={close} icon={<CloseOutlined />}>
          Fechar
        </Button>,
      ]}
    >
      <div style={{ padding: 20 }}>
        <FinancialReceiptReport financial={financial} />
      </div>
    </AModal>
  );
};

export default FinancialReceipt;
